import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Redirect, withRouter, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { PAGE_PATH, REMOTE_COMMAND } from '../lib/constants';
import { saveSessionStorage } from '../lib/tools';
import config from '../config';

const sessionStorageKey = config.sessionStorageKey.remote;

const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

const RemotePreparationContainer = ({ dispatch, match }) => {
  const query = useQuery();
  const command = match.params.command || null;
  if (command === REMOTE_COMMAND.caller) {
    const operatorIds = query.get('operatorIds');
    const oppositeOperatorIds = (operatorIds && JSON.parse(operatorIds)) || [];
    const deviceId = query.get('deviceId') || 0;
    const blackboardId = query.get('blackboardId') || 0;
    const favoriteId = query.get('favoriteId') || 0;
    saveSessionStorage(sessionStorageKey.oppositeOperatorIds, operatorIds);
    saveSessionStorage(sessionStorageKey.oppositeDeviceId, deviceId);
    saveSessionStorage(sessionStorageKey.blackboardId, blackboardId);
    saveSessionStorage(sessionStorageKey.favoriteId, favoriteId);
    dispatch({
      type: 'SET_REMOTE_INFO',
      oppositeOperatorIds,
      oppositeDeviceId: Number(deviceId),
      blackboardId: Number(blackboardId),
      favoriteId: Number(favoriteId),
    });
  }
  if (command === REMOTE_COMMAND.answer) {
    const appRoomId = query.get('appRoomId');
    saveSessionStorage(sessionStorageKey.appRoomId, appRoomId);
    dispatch({ type: 'SET_REMOTE_INFO', appRoomId });
  }
  const redirectPath = `${PAGE_PATH.DS_REMOTE}/${command}`;
  return <Redirect to={redirectPath} />;
};

RemotePreparationContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
};
export default withRouter(connect()(RemotePreparationContainer));
